export const authEndPoint = "https://accounts.spotify.com/authorize";

// const redirectURL = "http://localhost:3000/";

const redirectURL = "https://spotixy-3ae7d.web.app/";


const clientId = "0aa6b2ccbfaf466387f8b1c697c65214";

const scopes = [
    "user-read-currently-playing",
    "user-read-recently-played",
    "user-read-playback-state",
    "user-top-read",
    "user-modify-playback-state"
];

export const getTokenFromURL = () => {
    return window.location.hash.substring(1).split('&').reduce((initial, item) => {

        let parts = item.split("=");
        initial[parts[0]] = decodeURIComponent(parts[1]);

        return initial;
    }, {})
}

export const login_Url = `${authEndPoint}?client_id=${clientId}&redirect_uri=${redirectURL}&scope=${scopes.join("%20")}&response_type=token&show_dialog=true`;
